import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = {};

const set = (_, { payload }) => payload.links.reduce((links, link) => ({ ...links, [link.rel]: link }), {});

export default createReducer(initialState, {
  [actionTypes.FETCH_MESSAGES_SUCCESS]: set,
});
